import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guard/utility.guard";
import { InsightEgrcAuthoringToolsComponent } from "./authoring-tools/insight-egrc-authoring-tools.component";
import { DashboardComponent } from "./authoring-tools/dashboard/dashboard.component";
import { TechStackControlSearchComponent } from "./tech-stack-control/tech-stack-control-search/tech-stack-control-search.component";
import { TechStackControlCreateOrUpdateComponent } from "./tech-stack-control/tech-stack-control-create-or-update/tech-stack-control-create-or-update.component";
import { RiskRegisterSearchComponent } from "./risk-management/risk-register/risk-register-search/risk-register-search.component";
import { RiskRegisterCreateOrUpdateComponent } from "./risk-management/risk-register/risk-register-create-or-update/risk-register-create-or-update.component";
export const insightEgrcRoutes: Routes = [
  {
    path: "insight-egrc/auth-tools",
    component: InsightEgrcAuthoringToolsComponent,
    canActivate: [AuthGuard],
    children: [
      // { path: "", component: DashboardComponent },
      // {
      //   path: "tech-stack-control/search",
      //   component: TechStackControlSearchComponent,
      // },
      // {
      //   path: "tech-stack-control/create",
      //   component: TechStackControlCreateOrUpdateComponent,
      //   data: { create: true },
      // },
      // {
      //   path: "tech-stack-control/update/:techStackControlId",
      //   component: TechStackControlCreateOrUpdateComponent,
      //   data: { create: false },
      // },
      {
        path: "risk-management/risk-register-search",
        component: RiskRegisterSearchComponent,
      },
      {
        path: "risk-management/risk-register/create",
        component: RiskRegisterCreateOrUpdateComponent,
        data: { create: true },
      },
      {
        path: "risk-management/risk-register/update/:riskRegisterId",
        component: RiskRegisterCreateOrUpdateComponent,
        data: { create: false },
      },
    ],
  },

  {
    path: "insight-egrc/auth-tools",
    component: InsightEgrcAuthoringToolsComponent,
    canActivate: [AuthGuard],
  },
];

export const insightEgrcRouter = RouterModule.forChild(insightEgrcRoutes);
